/**
 * UID-416 / ADR-0131 D4 — client-side validation of a `linkPath` before this
 * SPA hands it to the router. The BFF composes and server-side-validates
 * `linkPath` (authoritative); this is DEFENCE IN DEPTH — the SPA validates
 * again before navigating, in case something between the two ever produces
 * a `linkPath` this component did not fetch itself.
 *
 * A SEPARATE, dedicated predicate from `isSafeCatalogImageRef`
 * (`../rfq/AddPartsModal.tsx`), deliberately: that one is `/assets/`-scoped
 * (it gates an `<img src>`) and would wrongly reject every legitimate
 * `linkPath`, which is a full app route like
 * `/catalog/series/Metal%20Spacers?brand=MISUMI`.
 *
 * The rule (same as the BFF's own `catalog-brand-link.ts`, kept in sync by
 * two independent test suites rather than a shared import across the repo
 * boundary): root-relative, not protocol-relative, no scheme before the
 * first `/`/`?`/`#`, and no `..` traversal segment.
 */
export function isSafeInternalPath(path: string | null | undefined): path is string {
  if (typeof path !== 'string' || path.length === 0) return false
  if (!path.startsWith('/')) return false
  if (path.startsWith('//')) return false
  if (path.includes('..')) return false
  const delimiterIndex = path.search(/[/?#]/)
  const beforeFirstDelimiter = delimiterIndex === -1 ? path : path.slice(0, delimiterIndex)
  if (beforeFirstDelimiter.includes(':')) return false
  return true
}
